/* Arctic Elegance — collection filtering and sorting without full page reloads.
   Falls back to normal form submission and links when JavaScript is unavailable. */
(function () {
  'use strict';

  var section = document.querySelector('[data-collection]');
  if (!section) return;
  var sectionId = section.getAttribute('data-section-id');
  var form = section.querySelector('[data-filter-form]');
  if (!form) return;
  var debounceTimer;
  var controller;

  function formUrl() {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '' && value !== null) params.append(key, value);
    });
    var query = params.toString();
    return form.getAttribute('action') + (query ? '?' + query : '');
  }

  function swap(selector, doc) {
    var fresh = doc.querySelector(selector);
    var current = section.querySelector(selector);
    if (current && fresh) current.replaceWith(fresh);
    else if (current && !fresh) current.remove();
    else if (!current && fresh) {
      var toolbar = section.querySelector('.collection__toolbar');
      if (toolbar) toolbar.insertAdjacentElement('afterend', fresh);
    }
  }

  function render(url, push) {
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
    section.classList.add('is-loading');

    fetch(fetchUrl, controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        swap('[data-collection-results]', doc);
        swap('[data-collection-count]', doc);
        swap('.active-filters', doc);

        var freshBody = doc.querySelector('.filter-drawer .drawer__body');
        var currentBody = section.querySelector('.filter-drawer .drawer__body');
        if (freshBody && currentBody) {
          // Keep open/closed state of groups
          var openStates = Array.prototype.map.call(currentBody.querySelectorAll('details'), function (d) { return d.open; });
          var focusedId = document.activeElement && currentBody.contains(document.activeElement) ? document.activeElement.id : null;
          currentBody.innerHTML = freshBody.innerHTML;
          currentBody.querySelectorAll('details').forEach(function (d, i) { if (openStates[i] !== undefined) d.open = openStates[i]; });
          if (focusedId) { var el = document.getElementById(focusedId); if (el) el.focus(); }
        }
        var freshButton = doc.querySelector('.collection__filter-button');
        var currentButton = section.querySelector('.collection__filter-button');
        if (freshButton && currentButton) currentButton.innerHTML = freshButton.innerHTML;

        if (push) window.history.pushState({ collectionUrl: url }, '', url);
        if (window.theme && window.theme.syncWishlistButtons) window.theme.syncWishlistButtons(section);
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') window.location.href = url;
      })
      .finally(function () { section.classList.remove('is-loading'); });
  }

  form.addEventListener('change', function (event) {
    var isPrice = event.target.type === 'number';
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { render(formUrl(), true); }, isPrice ? 600 : 150);
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    render(formUrl(), true);
    var dialog = form.querySelector('dialog[open]');
    if (dialog && window.theme) window.theme.closeDialog(dialog);
  });

  section.addEventListener('click', function (event) {
    var link = event.target.closest('[data-filter-link]');
    if (!link) return;
    event.preventDefault();
    render(link.getAttribute('href'), true);
    if (link.closest('.pagination')) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  window.addEventListener('popstate', function () {
    render(window.location.pathname + window.location.search, false);
  });
})();
